var _defs, _text, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonCropped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "612.4608819345661 366.592 333.88335704125177 90.112",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    style: {
      maxHeight: 500
    },
    width: 333.88335704125177,
    height: 90.112,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: none;\r\n        stroke: #d70a84;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #d70a84;\r\n        font-family: ProximaNova-Bold, 'Proxima Nova';\r\n        font-size: 22px;\r\n        font-weight: 700;\r\n      }\r\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(705.46 405.71)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    x: 0
  }, "EXPLORE "), /*#__PURE__*/React.createElement("tspan", {
    y: 26.4,
    x: 0
  }, "OPPORTUNITIES"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M901.54,371.77h-241.08c-20.59,0-37.53,15.55-39.75,35.55h49.65l-14.41-14.41c-1.74-1.74-1.74-4.56,0-6.3,1.74-1.74,4.56-1.74,6.3,0l21.91,21.91c.9.9,1.32,2.08,1.3,3.26.03,1.17-.4,2.36-1.3,3.26l-21.91,21.91c-1.74,1.74-4.56,1.74-6.3,0-1.74-1.74-1.74-4.56,0-6.3l14.41-14.41h-49.65c2.22,19.99,19.16,35.55,39.75,35.55h241.08c22.09,0,40-17.91,40-40h0c0-22.09-17.91-40-40-40Z",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonCropped);
export default __webpack_public_path__ + "static/media/button-cropped.168dd56dc47c20753b7d81b977cfdaad.svg";
export { ForwardRef as ReactComponent };